/**
 * Centralized default form fields.
 * Each call returns fresh field IDs via Date.now().
 */

const PHONE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 10px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-phone mr-2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>`;

const USER_ICON = `<svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 10px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user mr-2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>`;

const MAP_PIN_ICON = `<svg xmlns="http://www.w3.org/2000/svg" style="margin-top: 10px;" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin mr-2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>`;

const defaultFieldTemplates = [
	{
		type: 'email',
		label: 'Email',
		placeholder: 'Email Address',
		required: true
	},
	{
		hide: false,
		type: 'name',
		label: 'Name',
		required: false,
		middleInitial: false,
		prefix: false,
		suffix: false,
		icon: USER_ICON
	},
	{
		hide: false,
		type: 'phone',
		label: 'Mobile Phone',
		placeholder: 'Mobile Phone',
		required: false,
		digitLength: '',
		decimal: 0,
		format: 'National',
		country: '',
		default: '',
		icon: PHONE_ICON
	},
	{
		hide: true,
		type: 'homePhone',
		label: 'Home Phone',
		placeholder: 'Home Phone',
		required: false,
		digitLength: '',
		decimal: 0,
		format: 'National',
		country: '',
		default: '',
		icon: PHONE_ICON
	},
	{
		hide: true,
		type: 'businessPhone',
		label: 'Business Phone',
		placeholder: 'Business Phone',
		required: false,
		digitLength: '',
		decimal: 0,
		format: 'National',
		country: '',
		default: '',
		icon: PHONE_ICON
	},
	{
		hide: false,
		type: 'address',
		label: 'Address',
		required: false,
		country: '',
		options: {
			addressOne: true,
			addressTwo: true,
			city: true,
			province: true,
			postal: true,
			country: false
		},
		icon: MAP_PIN_ICON
	},
	{
		hide: false,
		type: 'isAgent',
		displayType: 'checkbox',
		label: 'Are you a realtor?',
		required: false,
		default: '',
		options: [{ option: 1 }, { option: 0 }],
		icon: MAP_PIN_ICON
	}
];

export function getDefaultFormFields() {
	const base = Date.now();
	return defaultFieldTemplates.map((template, index) => {
		const field = { ...template };
		field.id = base + index;
		return field;
	});
}
